// @flow

import React, { useEffect, useCallback } from 'react'
import $ from 'jquery'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import ReactHtmlParser from 'react-html-parser';
import { translate } from '../../helpers/global'

const PricingMoreNew = ({ globalGetLanguages }) => {
  useEffect(() => {
    window.scrollTo(0, 0)
    
    // Initialize modal close handlers
    $('.overlay, .close-button').off('click').on('click', function(event) {
      event.preventDefault();
      $('#modal-block').slideUp('fast');
      $('.overlay').fadeOut('fast');
      $('#btn-es1').addClass('hide');
      $('#btn-es2').addClass('hide');
    });

    // Add document click listener to close dropdown when clicking outside
    const handleDocumentClick = (event) => {
      const dropdownSelect = $(event.target).closest('.dropdown-select');
      if (dropdownSelect.length === 0) {
        $('.dropdown-content').css('display', 'none');
      }
    };

    $(document).on('click', handleDocumentClick);

    return () => {
      // Cleanup event listeners
      $('.overlay, .close-button').off('click');
      $(document).off('click', handleDocumentClick);
    };
  }, []);

  const showDropdown = useCallback(() => {
    $('.dropdown-content').css('display', 'block');
  }, []);

  const closeDropdown = useCallback(() => {
    $('.dropdown-content').css('display', 'none');
  }, []);

  const showModal0 = useCallback(() => {
    $('#modal-block').css('display', 'block');
    $('.overlay').fadeIn('fast');
    $('#btn-free').removeClass('hide');
    $('#btn-es1').addClass('hide');
    $('#btn-es2').addClass('hide');
  }, []);

  const showModal1 = useCallback(() => {
    $('#modal-block').css('display', 'block');
    $('.overlay').fadeIn('fast');
    $('#btn-free').addClass('hide');
    $('#btn-es1').removeClass('hide');
    $('#btn-es2').addClass('hide');
  }, []);

  const showModal2 = useCallback(() => {
    $('#modal-block').css('display', 'block');
    $('.overlay').fadeIn('fast');
    $('#btn-free').addClass('hide');
    $('#btn-es1').addClass('hide');
    $('#btn-es2').removeClass('hide');
  }, []);

  const chooseOpt = useCallback((val) => {
    closeDropdown();
    
    // Hide all plans first
    $('.plan-0, .plan-1, .plan-2, .plan-3').addClass('hide');
    
    // Show selected plan
    switch(val) {
      case '2':
        $('.plan-2').removeClass('hide');
        break;
      case '3':
        $('.plan-3').removeClass('hide');
        break;
      case '1':
        $('.plan-1').removeClass('hide');
        break;
      default:
        $('.plan-0').removeClass('hide');
        break;
    }
  }, [closeDropdown]);

  const renderHTML = useCallback((rawHTML) => 
    React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } })
  , []);
  return (
            <div id="pricing">
                <div id="modal-block" className="pop" style={{display: 'none'}}>
                    <div className="pop-head">
                        <span className='invisible'>{translate(globalGetLanguages,'REGISTER_POP_IF_YOU_APPLICANT')}</span>
                        <a className="close-button" href="#"><i className="fa fa-times" /></a>
                    </div>
                    <div className="pop-body">
                        <div className={`div-info`}>
                            <h1>Get Exactly What You Need</h1>
                            <p>At the check-out you will be able to add additional credits to top-up those already provided in your plan.</p>
                            <h2><span className='dollar'>$</span> 87.5 <span className='slash-block'>/block</span></h2>
                            <label>(1 block = 25 credits)</label>
                            <div id='btn-free' className='div-button hide'><Link to={{pathname: `/register`, query: { plan: 'free' }}}>{translate(globalGetLanguages,'GET_ASTRNT_FOR_FREE')}</Link></div>
                            <div id='btn-es1' className='div-button hide'><Link to={{pathname: `/register`, query: { plan: 'es1t' }}}>{translate(globalGetLanguages,'GET_FREE_TRIAL')}</Link></div>
                            <div id='btn-es2' className='div-button hide'><Link to={{pathname: `/register`, query: { plan: 'free' }}}>{translate(globalGetLanguages,'GET_FREE_TRIAL')}</Link></div>
                        </div>
                    </div>
                </div>

                <div className="overlay" style={{display: 'none'}} />

            <HeaderNewClear isOnStatusPricing="is-on" />
            <div className="pad-top desktop-hide" />
            <section className="section-pricing">
              {/* <div className="price-tit">
              {renderHTML(translate(globalGetLanguages,'PRICING_TITLE'))}
              </div> */}
              <ul className="the-price">
                <li>
                    <div className="box-price-container">
                        <div className="box-highlight">
                            <h1><strong>Inside the</strong> ASTRNT Platform</h1>
                            <p>Understand what’s available in each plan so you can choose what fits your organisation best.</p>
                        </div>
                        <div className="box-price box-price-desktop">
                            <div className="tit-price">
                                {/* <div>{translate(globalGetLanguages,'PLANS')}</div> */}
                                <div>Free</div>
                                <div>{translate(globalGetLanguages,'ENTERPRISE')}</div>
                            </div>
                            <hr className="divider" />
                            <div className="tit-price flex-container vertical--item-top">
                                {/* <div>{translate(globalGetLanguages,'PRICING_PLAN_TITLE')}</div> */}
                                <div className="feat-container">
                                    <div>
                                        <p>A great place to begin, especially for teams who want to try ASTRNT’s core capabilities. Assess 5 people per month. Get started now, no approvals needed.</p>
                                        <div className='div-harga'>Includes essential tools to get started</div>
                                    </div>
                                    <Link to={{pathname: `/register`, query: { plan: 'free' }}}>Start Your Free Plan</Link>
                                </div>
                                <div className="feat-container">
                                    <div>
                                        <p>For larger organizations or those needing custom assessments, integrations, and deeper analytics.</p>
                                        <div className='div-harga'>Unlock full platform features and integration capabilities</div>
                                    </div>
                                    <a href="https://meetings.hubspot.com/intan-khatulistiwa/talk-to-an-expert" rel="noopener noreferrer" target="_blank">Get Customised Proposal</a>
                                </div>

                                {/* <div className='div-plan-not-basic' style={{padding: '0'}}>
                                    <p>For larger organizations or those needing custom assessments, integrations, and deeper analytics.</p>
                                    <div className="div-dollar">
                                        <div style={{width: '100%'}}>
                                            <div className='div-harga'><strong>{translate(globalGetLanguages,'PRICING_PLAN_CUSTOM_PRICING')}</strong></div>
                                            <Link to={{pathname: `/register`, query: { plan: 'en1' }}}>Get Customised Proposal</Link>
                                            <p className="note-custom-pricing">{translate(globalGetLanguages,'PRICING_OFFER_ENTERPRISE')}</p>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>

                  <div className="box-price box-price-mobile">
                    <div className="tit-price tit-price-mobile horizontal-item--between">
                        <div className="plan-0">Free</div>
                        <div className="plan-1 hide">{translate(globalGetLanguages,'ENTERPRISE')}</div>
                        <div className="dropdown-select">
                          <button className="dropbtn" onClick={showDropdown}>{translate(globalGetLanguages,'PRICING_SWITCH_PLAN')}<i className="fas fa-chevron-right" /></button>
                          <div className="dropdown-content">
                              <div onClick={() => chooseOpt('0')}>Free</div>
                              <div onClick={() => chooseOpt('1')}>{translate(globalGetLanguages,'ENTERPRISE')}</div>
                          </div>
                        </div>
                    </div>
                    <div className="tit-price flex-container vertical--item-top">
                        <div>
                            <div className="feat-container plan-0">
                                <div>
                                    <p>A great place to begin, especially for teams who want to try ASTRNT’s core capabilities. Assess 5 people per month. Get started now, no approvals needed.</p>
                                    <div className='div-harga'>Includes essential tools to get started</div>
                                </div>
                                <Link to={{pathname: `/register`, query: { plan: 'free' }}}>Start Your Free Plan</Link>
                            </div>
                            <div className="feat-container plan-1 hide">
                                <div>
                                    <p>For larger organizations or those needing custom assessments, integrations, and deeper analytics.</p>
                                    <div className='div-harga'>Unlock full platform features and integration capabilities</div>
                                </div>
                                <a href="https://meetings.hubspot.com/intan-khatulistiwa/talk-to-an-expert" rel="noopener noreferrer" target="_blank">Get Customised Proposal</a>
                            </div>
                            {/* <p className="plan-0">A great place to begin, especially for teams who want to try ASTRNT’s core capabilities. Assess 5 people per month. Get started now, no approvals needed.</p>
                            <p className="plan-1 hide">For larger organizations or those needing custom assessments, integrations, and deeper analytics.</p>
                            <div className="div-dollar div-dollar-mobile flex-container">
                                <div className="plan-0">
                                    <b>Free</b>
                                        
                                        <Link style={{marginTop: '48px'}} to={{pathname: `/register`, query: { plan: 'free' }}}>Get ASTRNT For Free</Link>
                                </div>
                                <div className="plan-1 hide">
                                    <Link to={{pathname: `/register`, query: { plan: 'en1' }}}>{translate(globalGetLanguages,'GET_FREE_TRIAL')}</Link>
                                    <p className="note-custom-pricing">{translate(globalGetLanguages,'PRICING_OFFER_ENTERPRISE')}</p>
                                </div>
                            </div> */}
                        </div>
                    </div>
                  </div>

                  <div className="comparison-list comparison-list-desktop">
                    <div className="feature-list">
                        <div className="list-compare">
                            <div>Applicant Tracking</div>
                            <div> <i className="fas fa-check icon-space" /> Always Free</div>
                            <div> <i className="fas fa-check icon-space" /> Always Free</div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_#_CANDIDATE_RESPONSE_1')}</div>
                            <div>5/month<a onClick={showModal0}></a></div>
                            <div>{translate(globalGetLanguages,'UNLIMITED')}</div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_#_USER_TEAM_MEMBER_RESPONSE')}</div>
                            <div>{translate(globalGetLanguages,'UNLIMITED')}</div>
                            <div>{translate(globalGetLanguages,'UNLIMITED')}</div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_#_OF_JOBS')}</div>
                            <div>{translate(globalGetLanguages,'UNLIMITED')}</div>
                            <div>{translate(globalGetLanguages,'UNLIMITED')}</div>
                        </div>
                    </div>
                    <div className="feature-list">
                        <label>{translate(globalGetLanguages,'PRICING_CORE_ASSESSMENT')}</label>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_CORE_ASSESSMENT_TEXT_1')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_CORE_ASSESSMENT_TEXT_2')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_CORE_ASSESSMENT_TEXT_3')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_CORE_ASSESSMENT_TEXT_4')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_CORE_ASSESSMENT_TEXT_5')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_CORE_ASSESSMENT_TEXT_6')}</div>
                            <div><i className="fas fa-times-circle" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_CORE_ASSESSMENT_TEXT_7')}</div>
                            <div>{translate(globalGetLanguages,'SOON')}</div>
                            <div>{translate(globalGetLanguages,'SOON')}</div>                           
                        </div>
                    </div>
                    <div className="feature-list">
                        <label>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY')}</label>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_1')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_2')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_3')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_4')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_5')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_6')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_7')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_8')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_9')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_10')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_11')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_12')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_13')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_14')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_15')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_16')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_17')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                    </div>
                    <div className="feature-list">
                        <label>{translate(globalGetLanguages,'PRICING_FAIRNESS_INTEGRITY')}</label>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_FAIRNESS_INTEGRITY_TEXT_1')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div style={{whiteSpace: 'pre-line'}}>{translate(globalGetLanguages,'PRICING_FAIRNESS_INTEGRITY_TEXT_2')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                    </div>
                    <div className="feature-list">
                        <label>{translate(globalGetLanguages,'PRICING_REVIEW_REPORTING')}</label>
                        <div className="list-compare">
                            <div>Customisable Staging Name</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_REVIEW_REPORTING_TEXT_1')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div style={{whiteSpace: 'pre-line'}}>{translate(globalGetLanguages,'PRICING_REVIEW_REPORTING_TEXT_2')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div style={{whiteSpace: 'pre-line'}}>{translate(globalGetLanguages,'PRICING_REVIEW_REPORTING_TEXT_3')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                    </div>
                    <div className="feature-list">
                        <label>{translate(globalGetLanguages,'PRICING_CANDIDATE_EXPERIENCE')}</label>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_CANDIDATE_EXPERIENCE_TEXT_1')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_CANDIDATE_EXPERIENCE_TEXT_2')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_CANDIDATE_EXPERIENCE_TEXT_3')}</div>
                            <div><i className="fas fa-times-circle" /></div>
                            <div><i className="fas  fa-check" /></div>
                        </div>
                    </div>
                    <div className="feature-list">
                        <label>{translate(globalGetLanguages,'PRICING_INTEGRATION')}</label>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_INTEGRATION_TEXT_1')}</div>
                            <div><i className="fas fa-times-circle" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_INTEGRATION_TEXT_2')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_INTEGRATION_TEXT_3')}</div>
                            <div><i className="fas fa-times-circle" /></div>
                            <div><i className="fas  fa-check" /></div>
                        </div>
                    </div>
                    <div className="feature-list">
                        <label>{translate(globalGetLanguages,'PRICING_DATA_SECURITY')}</label>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_DATA_SECURITY_TEXT_1')}</div>
                            <div><i className="fas fa-check" /></div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                    </div>
                  </div>

                  <div className="comparison-list comparison-list-mobile">
                    <div className="feature-list">
                          <div className="list-compare">
                            <div>Applicant Tracking</div>
                            <div><i className="fas fa-check icon-space" /> Always Free</div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_#_CANDIDATE_RESPONSE_1')}</div>
                            <div>
                                <span className="plan-0">5/month<br/><a onClick={showModal0}></a></span>
                                <span className="plan-1 hide">{translate(globalGetLanguages,'UNLIMITED')}</span>
                            </div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_#_USER_TEAM_MEMBER_RESPONSE')}</div><div>{translate(globalGetLanguages,'UNLIMITED')}</div></div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_#_OF_JOBS')}</div><div>{translate(globalGetLanguages,'UNLIMITED')}</div></div>
                    </div>
                    <div className="feature-list">
                        <label>{translate(globalGetLanguages,'PRICING_CORE_ASSESSMENT')}</label>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_CORE_ASSESSMENT_TEXT_1')}</div>
                            <div>
                                <i className="fas fa-check" />
                            </div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_CORE_ASSESSMENT_TEXT_2')}</div>
                        <div>
                            <i className="fas fa-check " />
                            </div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_CORE_ASSESSMENT_TEXT_3')}</div>
                            <div>
                                <i className="fas fa-check" />
                            </div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_CORE_ASSESSMENT_TEXT_4')}</div>
                            <div>
                                <i className="fas fa-check" />
                            </div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_CORE_ASSESSMENT_TEXT_5')}</div>
                            <div>
                                <i className="fas fa-check" />
                            </div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_CORE_ASSESSMENT_TEXT_6')}</div>
                            <div>
                                <i className="fas fa-times-circle plan-0" />
                                <i className="fas fa-check plan-1 hide" />
                            </div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_CORE_ASSESSMENT_TEXT_7')}</div>
                            <div>{translate(globalGetLanguages,'SOON')}</div>
                        </div>
                    </div>          
                    <div className="feature-list">
                        <label>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY')}</label>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_1')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_2')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_3')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_4')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_5')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_6')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_7')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_8')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_9')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_10')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_11')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_12')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_13')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_14')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_15')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_16')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_ASSESSMENT_INVENTORY_TEXT_17')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                    </div>
                    <div className="feature-list">
                        <label>{translate(globalGetLanguages,'PRICING_FAIRNESS_INTEGRITY')}</label>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_FAIRNESS_INTEGRITY_TEXT_1')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_FAIRNESS_INTEGRITY_TEXT_2')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                    </div>
                    <div className="feature-list">
                        <label>{translate(globalGetLanguages,'PRICING_REVIEW_REPORTING')}</label>
                        <div className="list-compare">
                            <div>Customisable Staging Name</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_REVIEW_REPORTING_TEXT_1')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_REVIEW_REPORTING_TEXT_2')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_REVIEW_REPORTING_TEXT_3')}</div>
                            <div><i className="fas fa-check" /></div>
                        </div>
                    </div>
                    <div className="feature-list">
                        <label>{translate(globalGetLanguages,'PRICING_CANDIDATE_EXPERIENCE')}</label>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_CANDIDATE_EXPERIENCE_TEXT_1')}</div>
                            <div>
                                <i className="fas fa-check" />
                            </div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_CANDIDATE_EXPERIENCE_TEXT_2')}</div><div><i className="fas fa-check" /></div></div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_CANDIDATE_EXPERIENCE_TEXT_3')}</div>
                            <div>
                                <i className="fas fa-times-circle plan-0" />
                                <i className="fas fa-check plan-1 hide" />
                            </div>
                        </div>
                    </div>
                    <div className="feature-list">
                        <label>{translate(globalGetLanguages,'PRICING_INTEGRATION')}</label>
                        <div className="list-compare">
                            <div>{translate(globalGetLanguages,'PRICING_INTEGRATION_TEXT_1')}</div>
                            <div>
                                <i className="fas fa-times-circle plan-0" />
                                <i className="fas fa-check plan-1 hide" />
                            </div>
                        </div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_INTEGRATION_TEXT_2')}</div><div><i className="fas fa-check" /></div></div>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_INTEGRATION_TEXT_3')}</div>
                            <div>
                                <i className="fas fa-times-circle plan-0" />
                                <i className="fas fa-check plan-1 hide" />
                            </div>
                        </div>
                    </div>
                    <div className="feature-list">
                        <label>{translate(globalGetLanguages,'PRICING_DATA_SECURITY')}</label>
                        <div className="list-compare"><div>{translate(globalGetLanguages,'PRICING_DATA_SECURITY_TEXT_1')}</div><div><i className="fas fa-check" /></div></div>
                    </div>
                  </div>

                  {/* <div className="div-ngo-startup">
                    <label>{translate(globalGetLanguages,'PRICING_ARE_YOU_NGO')}</label>
                    <p>{translate(globalGetLanguages,'PRICING_ARE_YOU_NGO_TEXT_1')}</p>
                    <Link to={{pathname: `/register`, query: { plan: 'ngo' }}} className="button-apply-now">{translate(globalGetLanguages,'APPLY_NOW')}</Link>
                </div> */}
                
                </li>
              </ul>
            </section>
            <FooterNew />
          </div>
        )
};


const mapStateToProps = (state, ownProps) => {
    return {
      globalGetLanguages:state.globalGetLanguages,
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {
    }
  }
  
export default connect(mapStateToProps, mapDispatchToProps)(PricingMoreNew)

